<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M40.7845 40.1987C40.2845 40.6017 39.5642 40.5718 39.0978 40.124C38.5492 39.5941 38.5828 38.7022 39.1761 38.2171L62.2497 19.3753L60.8578 18.2073C60.3876 17.8155 59.7084 17.8117 59.2344 18.1961L34.7204 38.2134C34.127 38.6985 34.0934 39.5904 34.642 40.1203C35.1048 40.5644 35.8287 40.598 36.3288 40.1949L36.4109 40.1278V108.087H40.8704"
            class="primary-fill" />
        <path
            d="M40.7845 40.1987C40.2845 40.6017 39.5642 40.5718 39.0978 40.124C38.5492 39.5941 38.5828 38.7022 39.1761 38.2171L62.2497 19.3753L60.8578 18.2073C60.3876 17.8155 59.7084 17.8117 59.2344 18.1961L34.7204 38.2134C34.127 38.6985 34.0934 39.5904 34.642 40.1203C35.1048 40.5644 35.8287 40.598 36.3288 40.1949L36.4109 40.1278V108.087H40.8704"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M41.0195 40.4972V108.095H88.9206V45.1432"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M40.7988 40.1725H82.5164"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M53.6995 47.6585C55.3303 47.6585 56.6551 48.9833 56.6551 50.6141V56.2267H50.7402V50.6141C50.7402 48.9833 52.065 47.6585 53.6958 47.6585H53.6995Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.2425 61.3391C66.8733 61.3391 68.1981 62.6639 68.1981 64.2947V69.9073H62.2832V64.2947C62.2832 62.6639 63.608 61.3391 65.2388 61.3391H65.2425Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.555 74.8445C78.1858 74.8445 79.5106 76.1693 79.5106 77.8001V83.4127H73.5957V77.8001C73.5957 76.1693 74.9205 74.8445 76.5513 74.8445H76.555Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.6854 51.9053V50.6141C73.6854 48.9795 75.0102 47.6585 76.6409 47.6585C78.2755 47.6585 79.5965 48.9833 79.5965 50.6141V56.2267H73.6816V54.9504"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M62.16 78.6845V77.3933C62.16 75.7587 63.4848 74.4377 65.1156 74.4377C66.7501 74.4377 68.0711 75.7625 68.0711 77.3933V83.0059H62.1562V81.7296"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M50.9529 65.7314V64.4402C50.9529 62.8057 52.2777 61.4847 53.9085 61.4847C55.543 61.4847 56.8641 62.8095 56.8641 64.4402V70.0528H50.9492V68.7766"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M62.25 56.2267V50.6141C62.25 48.9795 63.5748 47.6585 65.2056 47.6585C66.8401 47.6585 68.1611 48.9833 68.1611 50.6141V56.2267H65.2914"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M50.8828 83.379V77.7664C50.8828 76.1319 52.2076 74.8109 53.8384 74.8109C55.4729 74.8109 56.7939 76.1356 56.7939 77.7664V83.379H53.9242"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.6172 69.8924V64.2798C73.6172 62.6453 74.942 61.3243 76.5728 61.3243C78.2073 61.3243 79.5283 62.649 79.5283 64.2798V69.8924H76.6586"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.399 89.9171C69.1047 89.9171 72.1125 92.9249 72.1125 96.6306V108.095H58.6855V96.6306C58.6855 92.9249 61.6934 89.9171 65.399 89.9171Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.5527 92.563V107.856"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.6167 106.486H56.7715V107.99H73.6167V106.486Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M58.3652 23.1034L63.9442 18.6402C64.81 17.9498 66.0452 17.9722 66.8812 18.6999L85.0064 34.4294C87.2305 36.299 88.518 39.0493 88.5329 41.9526L88.8054 89.07C88.8277 92.6414 90.1898 96.1045 92.7237 98.6234C94.2426 100.131 96.1756 101.34 98.4819 101.34C104.169 101.34 104.986 91.4024 98.3027 91.4024C91.6191 91.4024 85.9244 102.788 90.2607 110.558"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
    </svg>
</template>
